import {Pipe, PipeTransform} from "@angular/core";
import * as moment from "moment";

@Pipe({
    name: "moment"
})

export class MomentPipe implements PipeTransform {
    static staticTransform(date: moment.Moment, format?: string): string {
        return moment.isMoment(date) ? date.format(format) : "";
    }
    transform(date: moment.Moment, format?: string): string {
        return MomentPipe.staticTransform(date, format);
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/CustomPipes/MomentPipe.ts